import { Link } from '@mui/material'
import React from 'react'
import styles from "../components/laymanComp_css/LaymanPage39.module.css"

export default function LaymanPage39() {
  return (
    <>
      <div className={styles.layman_block_2}>
        <div className={styles.block1_main_wrpr}>
          <div className={styles.block1_main_bg}>
            <div className={styles.common_width_1}>
              <div className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}>
                <div className={styles.column}>
                  <div className={`${styles.col12} ${styles.bgifive}`}>
                    <h1>ARCHETYPE OF AQUARIUS</h1>
                  </div>
                </div>
              </div>
            </div>



            <div className={styles.common_width}>
              <div className={styles.om_block_main}>
                <div
                  className={`${styles.om_block1_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/aquarius/aquarius_1img.webp" /> */}
                    <img  src={`${process.env.cloud_url}Layman-Symbolism/aquarius/aquarius_1img.webp`}/> 

                  </div>
                  {/* className={styles.yellow_txt} */}
                  <div className={styles.layman_txt_box_wrpr}>
                    <div className={styles.layman_txt_box_innr}>
                      {/* <div className={styles.layman_yellow_commn_header}>
                        <h2>Virgo's Wisdom: The Virgin Journey of Introspection</h2>
                      </div> */}
                      <p>
                        Aquarius is a Cosmic Archetype within the School of <Link href="https://www.divineinfinitebeing.com">Divine Infinite Being</Link> method and Archetypal
                        Astrology, representing a Fixed Air Influence. This Archetype, with its contemporary resonance,
                        mirrors the rapid evolution of modern technology and the ceaseless exploration into the future—a manifestation of the Aquarian spirit.

                      </p>
                      <p>The Aquarian Archetype has left its indelible mark throughout history, notably during the Hellenistic age in Alexandria, Egypt. However, the Age of Aquarius is more than a historical echo; it's an active force shaping our present. The essence of Aquarius propels us toward new horizons, fueling our
                        journey with fresh insights and groundbreaking discoveries.
                      </p>
                      {/* <div className={styles.layman_yellow_commn_header}>
                        <h2>The Symbolic Essence of OM:</h2>
                      </div> */}
                      <p>
                        In the Thoth Tarot, Aquarius is embodied by <span><i>"The Star,"</i></span> an image of stability and fixed influence. The figure, pouring celestial brilliance onto the earth, captures the essence of Aquarian ideals—the
                        fusion of open expression, individual liberty, and the melding of diverse ideas. This Archetype
                        encapsulates the fundamental right to freedom, a quintessentially Aquarian principle that
                        reverberates across the free world.
                      </p>
                      <p>
                        <span><i>"The Star"</i></span> also symbolizes the dual nature of Aquarian influence. It offers humanity not only its brightest ideas but also the tools that could lead to both prosperity and peril. Aquarius, like the
                        genius wielding a wand or a weapon, embodies the transformative power of its inspiration.
                      </p>
                      <p>
                        To work under the influence of Aquarius is to open oneself to Higher Genius and Inspiration. <span><i>"The Star"</i></span> depicts the water bearer channeling the light of the stars onto the earth, a metaphor for drawing profound insights from the watery depths of the Collective Unconscious. This process transcends boundaries and prejudices, reflecting the boundless nature of Aquarian consciousness.
                      </p>
                      <p>
                        In embracing the Aquarian spirit, individuals tap into the collective wellspring of knowledge,
                        contributing to the ever-evolving journey of human progress. As we navigate the Age of Aquarius, the Archetype encourages us to explore, discover, and harness the transformative power of the Higher Genius for the betterment of humanity.
                      </p>


                    </div>
                  </div>
                </div>
                {/* <div
                  className={`${styles.om_block2_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    <img
                      className={styles.orphic_egg_img1}
                      src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/aquarius/aquarius_2img.webp"
                    />
                  </div>

                  <div className={styles.layman_txt_box_wrpr}>
                    <div className={styles.layman_txt_box_innr}>
                      <div className={styles.layman_yellow_commn_header}>
                        <h2>Astrological Features:</h2>
                      </div>
                      <p>
                        To work under the influence of Virgo is to weave together wisdom, introspection, and a scholarly approach to existence. It is a continuous study of new things while deepening the habit of
                        peering into one's current and past life processes. Virgo invites individuals to embrace a
                        springtime thinking in the vast history of our race, committing to the virgining
                        "Cosmic Process" of their Transpersonal Journey.
                      </p>

                      <p>
                        As we navigate the intricate tapestry of life under the guidance of Virgo, we find ourselves
                        immersed in the timeless pursuit of self-discovery and wisdom, each moment an opportunity
                        to uncover the hidden truths within the vast expanse of our existence.
                      </p>
                      <div className={styles.layman_yellow_commn_header}>
                        <h2>Astrological Features:</h2>
                      </div>
                      <div className={styles.bullet_cont}>
                        <p>Cosmic Archetype: Virgo is a significant Cosmic Archetype within the School of Divine
                          Infinite Being method and Archetypal Astrology, embodying the essence of Mutable
                          Earth Influence.</p>
                        <p>
                          Introspection and Reflection: Virgo symbolizes a deep call to introspection and reflection, akin to the profound introspective years of influential figures like Carl Jung, Aleister Crowley, <span className={styles.yellow_txt}>Marie-Louise von Franz,</span> Joan of Arc, Socrates, and Werner Heisenberg.
                        </p>
                        <p>
                          Virgin Symbolism: The <span>"virgin"</span> aspect of Virgo signifies innocence and freshness at various stages of life—from birth to the awakening of puberty, the first sexual experience, and
                          ultimately unto death.
                        </p>
                        <p>
                          Hidden Meanings: Virgo calls individuals to delve deeply into hidden meanings within their experiences, guided by the Mercurial messenger as Virgo is ruled by Mercury.
                        </p>
                        <p>
                          Thoth Tarot - The Hermit: The Virgo influence is represented by <span>"The Hermit"</span> in the Thoth Tarot, depicting an Old Sage mesmerized by the <span className={styles.yellow_txt}>Orphic Egg,</span> symbolizing the continuous
                          process of creation.
                        </p>
                        <p>
                          Hounds of Hell Symbolism: The hounds of hell at <span className={styles.yellow_txt}>the Hermit's feet</span>, sacred to Hecate
                          of the Underworld, represent the tamed aspects of the unconscious during the process
                          of introspection.
                        </p>
                      </div>


                    </div>
                  </div>
                </div> */}
                {/* <div
                  className={`${styles.om_block3_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/virgo/vigro_3img.webp" />
                  </div>

                  <div className={`${styles.layman_txt_box_wrpr} ${styles.bullet_cont}`}>

                    <div className={styles.layman_txt_box_innr}>
                    
                      <p>
                        <b>Lantern of Knowledge:</b> The <span className={styles.yellow_txt}>Hermit carries the Lantern</span>, symbolizing the knowledge of the Hidden Inner Light gained through a lifetime of introspective experiences.
                      </p>

                      <p>

                        <b>Eternal Virgin Experience:</b> The Hermit's secret knowledge lies in understanding the eternal Virgin experience within the wonder of existence, representing the matured flowering of the life process.

                      </p>
                      <p>
                        <b>Scholarly Approach:</b> Working under the influence of <span className={styles.yellow_txt}>Virgo encourages a scholarly approach</span> to existence, combining wisdom, introspection, and continuous study of new things.
                      </p>
                      <p>
                        <b>Springtime Thinking:</b> Virgo invites individuals to adopt a springtime thinking in the vast
                        history of the human race, committing to the ongoing <span>"Cosmic Process"</span> of their
                        Transpersonal Journey.
                      </p>

                    </div>
                  </div>
                </div> */}
                <div
                  className={`${styles.om_block4_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img
                      className={styles.orphic_egg_img1}
                      src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/aquarius/aquarius_2img.webp"
                    /> */}
                    <img  className={styles.orphic_egg_img1}  src={`${process.env.cloud_url}Layman-Symbolism/aquarius/aquarius_2img.webp`}/> 

                  </div>

                  <div className={`${styles.layman_txt_box_wrpr} ${styles.bullet_cont}`}>
                    <div className={styles.layman_txt_box_innr}>
                      <div className={styles.layman_yellow_commn_header}>
                        <h2>Astrological Features:</h2>
                      </div>
                      <p>
                        <b>Fixed Air Influence:</b> Aquarius is a Fixed sign associated with the Air element, emphasizing stability and intellectual pursuits.

                      </p>

                      <p>
                        <b>Genius and Imagination:</b> Aquarius is linked to higher intelligence, inventive thinking, and the capacity for groundbreaking ideas.
                      </p>
                      <p>
                        <b>Technological Advancements:</b> The Archetype of Aquarius is closely connected to technological
                        progress and the exploration of new horizons.
                      </p>

                      <p>
                      <b>Liberty and Individualism:</b> Aquarius values freedom, individual rights, and the expression of unique perspectives, promoting a sense of personal liberty.
                      </p>

                      <p>
                      <b>Humanitarianism:</b> There's a strong humanitarian aspect to Aquarius, fostering a sense of community and a concern for collective well-being.
                      </p>

                      <p>
                      <b>The Star in the Thoth Tarot:</b> Represented by <span><i>"The Star"</i></span> card, Aquarius pours the Genius of the Stars onto the Earth, symbolizing inspiration and cosmic insight.
                      </p>
                      <p>
                      <b>Collective Unconscious:</b> Aquarius draws from the collective unconscious, inspiring individuals to tap into shared knowledge and universal consciousness.

                      </p>
                      <p>
                      <b>Inclusivity:</b> This Archetype encourages inclusivity, breaking down boundaries and fostering a sense of unity among diverse individuals.

                      </p>
                      <p>
                      <b>Progressive Ideals:</b> Aquarius leans towards progressive ideals, encouraging societal advancements and a willingness to embrace change.
                      </p>
                      <p>
                      <b>Balance of Technology and Spirituality:</b> Aquarian influence involves a balance between technological innovation and spiritual insight, emphasizing the importance of both aspects in human development.

                      </p>

                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* =========================================greensec---------------------------------------------               */}

            <div className={styles.green_sec_cmn_main_wrp}>
              <div className={styles.common_width}>
                <Link href="/rota-the-wheel">
                  <div className={styles.green_sec_cmn_sub_wrp}>
                    <h1>The Astrological Tarot association for Aquarius <br /> The Star. See our alchemical ROTA here.</h1>
                  </div>
                </Link>
              </div>
            </div>
            {/* ---------------------------------------------------greensec_end=================================== */}



            {/* <div className={styles.demo_image}>
              <div className={styles.block1_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/LAYMAN_AQUARIUS/aquarius_block1_img.webp'></img>
              </div>

              <div className={styles.block2_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/LAYMAN_AQUARIUS/aquarius_block2_img.webp'></img>
              </div>

              <div className={styles.block5_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/LAYMAN_AQUARIUS/aquarius_link_block3_img.webp'></img>
                <Link className={styles.blank_link} href="/rota-the-wheel"></Link>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  )
}
